export default {"src":"/_next/static/media/paperless.9a954f18.svg","height":96,"width":96};